import PropTypes from 'prop-types';
import {ReactComponent as Minus} from '~/assets/icons/minus.svg';
import {ReactComponent as Plus} from '~/assets/icons/plus.svg';

const MIN_QTY = 1;
const MAX_QTY = 99;

/**
 * Opinionated QuantityPicker component that tracks a positive integer in state,
 * broadcasting that number to a parent via a provided callback.
 * For now, this does not accept typing, and operates solely via the -/+ buttons,
 * but that may change
 */

export function QuantityPicker({callback, quantity}) {
  const handleChange = (sum) => {
    const next = quantity + sum;
    if (next < MIN_QTY) return;
    if (next > MAX_QTY) return;

    callback(next);
  };

  return (
    <>
      <div className="quantity-picker">
        <button
          className="quantity-picker__btn"
          onClick={() => handleChange(-1)}
        >
          <Minus />
        </button>
        <div className="quantity-picker__quantity">{quantity}</div>
        <button
          className="quantity-picker__btn"
          onClick={() => handleChange(1)}
        >
          <Plus />
        </button>
      </div>
    </>
  );
}

QuantityPicker.propTypes = {
  callback: PropTypes.func.isRequired,
  quantity: PropTypes.number.isRequired,
};
